import { useState, useEffect, useRef } from "react";
import { createFilterOptions } from '../../../util/Util'
import RefreshButton from "../../../components/RefreshButton";
import { useUI } from "../../../providers/MoleUIContext";
import { useAppSocket } from "../../../providers/AppSocketContext";
import { useAuth } from "../../../hooks/useAuth";
import { Autocomplete, Grid, TextField } from "@mui/material";
import ValueSelector from "../ValueSelector";
import { useTranslation } from "react-i18next";

interface Props {
	selectedDepot: any;
	setSelectedDepot: (value: any) => void;
	setParams: (value: Record<string, any>) => void;
}

const Detail = ({ selectedDepot, setSelectedDepot, setParams }: Props) => {
	const { t } = useTranslation("common");
	const [depots, setDepots] = useState<any[]>([]);
	const [isDepotLoading, setIsDepotLoading] = useState<boolean>(false);

	const { queueReRun } = useUI();
	const { api } = useAuth();



	const fetchDepots = async () => {
		setIsDepotLoading(true);

		const res = await api.get("/depot/meterred",
			{
				params: { Scope: "inventory" },
			}
		);

		if (res) {
			if (res.status === 200) {
				setDepots(res.data);
			} else if (res.status === 401 || res.status === 422) {
				queueReRun(fetchDepots);
			} else {
				console.error("Failed to fetch data:", res);
			}
		}

		setIsDepotLoading(false);
	};

	useEffect(() => {
		fetchDepots();
	}, []);



	return (
		<Grid container spacing={0}>
			<Grid size="auto" minWidth={150} >
				<Autocomplete
					id="depotInput"
					size="small"
					options={depots}
					filterOptions={createFilterOptions((opt) => opt.DepotName || "")}
					getOptionLabel={(depot) => depot.DepotName || ""}
					value={depots.find((d) => d.id === selectedDepot?.id) || null}
					onChange={(_, newValue) => {
						setSelectedDepot(newValue);
					}}
					loading={isDepotLoading}
					autoHighlight
					autoComplete
					autoSelect
					disabled={isDepotLoading}
					renderInput={(params) => (
						<TextField
							{...params}
							label={
								<span>
									{t("ui.labels.depot")}&nbsp;&nbsp;
									<RefreshButton isWorking={isDepotLoading} onClick={fetchDepots} disabled={isDepotLoading} />
								</span>
							}
							fullWidth
						/>
					)}
				/>
			</Grid>
			<Grid size="grow" >
				<ValueSelector
					onChange={setParams}
				/>
			</Grid>
		</Grid>
	);
};

export default Detail;
